<div class="loginContainer white">
	<div class="containerInfo">
		<div class="productionLogikImage">
			<img src="/assets/img/production_logik_wh_bk.png" alt="Production logik">	
		</div>
		<p>{{'Invalid login, please contact' | translate }} productionlogik&#64;spe.sony.com</p>
		<a [routerLink]="['/login']" class="loginlink">{{'Continue' | translate}}</a>
	</div>
</div>